
















































import { Component, Model, Prop, Ref, Vue } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

@Component({
  components: {
    ListItem
  }
})
export default class SwitchListItem extends Vue {
  @Model('change', { type: Boolean, required: true })
  value!: boolean

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean

  @Prop({ type: [Boolean, String], default: false })
  readonly divider!: boolean | 'full' | 'inset'

  @Prop({ type: Boolean, default: false })
  readonly lastDivider!: boolean

  @Prop({ type: Boolean, default: false })
  readonly detailsTransition!: boolean

  transitionDirection = [
    'opacity-0 translate-x-32',
    'opacity-0 -translate-x-32'
  ]

  @Ref()
  readonly switchRef!: Vue

  toggleSwitch (event: Event) {
    const input = this.switchRef.$el.firstElementChild as HTMLInputElement

    if ((event.target as Element) !== input) {
      input.click()
    }
  }

  checkDetailsSlot () {
    return this.$slots.details !== undefined
  }
}
